function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is

/**
 * @internal
 */
function addAutoIpAddressToUser(objWithMaybeUser) {
  var _objWithMaybeUser$use;

  if (((_objWithMaybeUser$use = objWithMaybeUser.user) === null || _objWithMaybeUser$use === void 0 ? void 0 : _objWithMaybeUser$use.ip_address) === undefined) {
    objWithMaybeUser.user = _objectSpread(_objectSpread({}, objWithMaybeUser.user), {}, {
      ip_address: '{{auto}}'
    });
  }
}
/**
 * @internal
 */


function addAutoIpAddressToSession(session) {
  if ('aggregates' in session) {
    var _session$attrs;

    if (((_session$attrs = session.attrs) === null || _session$attrs === void 0 ? void 0 : _session$attrs['ip_address']) === undefined) {
      session.attrs = _objectSpread(_objectSpread({}, session.attrs), {}, {
        ip_address: '{{auto}}'
      });
    }
  } else {
    if (session.ipAddress === undefined) {
      session.ipAddress = '{{auto}}';
    }
  }
}

export { addAutoIpAddressToSession, addAutoIpAddressToUser };